import { DbState, defaultDbState } from 'contexts/db-state';
import { createContext } from 'react';
import { CatchWeight, Company, EquipmentShortReason, EquipmentType, SyncStatus, FilteredLicensePlate, LicensePlate, LicensePlateItem, LineItem, LineItemBarcode, Mispick, Order, OrderItem, OrderItemChange, OrderLicensePlate, ReconcileReason, RefusalReason, ReturnChangeReason, ReturnItem, Signature, Stop, StopEquipment, Trip, VerifyMultipleItemsReason, OrderItemChangeImage } from 'services/types';
import { CompanyEmail } from 'services/types/companyEmail';

export type TripContextData = {
    trips: DbState<Trip>,
    stops: DbState<Stop>,
    stopEquipments: DbState<StopEquipment>,
    equipmentTypes: DbState<EquipmentType>,
    equipmentShortReasons: DbState<EquipmentShortReason>,
    orderItems: DbState<OrderItem>,
    orders: DbState<Order>,
    lineItems: DbState<LineItem>,
    lineItemBarcodes: DbState<LineItemBarcode>,
    signatures: DbState<Signature>,
    mispicks: DbState<Mispick>,
    licensePlates: DbState<LicensePlate>,
    orderItemChanges: DbState<OrderItemChange>,
    catchWeights: DbState<CatchWeight>,
    licensePlateItems: DbState<LicensePlateItem>,
    orderLicensePlates: DbState<OrderLicensePlate>,
    reconcileReasons: DbState<ReconcileReason>,
    refusalReasons: DbState<RefusalReason>,
    companies: DbState<Company>,
    verifyMultipleItemsReasons: DbState<VerifyMultipleItemsReason>,
    returnItems: DbState<ReturnItem>,
    returnChangeReasons: DbState<ReturnChangeReason>,
    syncStatus: DbState<SyncStatus>,
    filteredLicensePlates: DbState<FilteredLicensePlate>,
    orderItemChangeImages: DbState<OrderItemChangeImage>,
    companyEmail: DbState<CompanyEmail>,
    companyEmailAdditions: DbState<CompanyEmail>,
    companyEmailDeletions: DbState<CompanyEmail>,
    isReady: () => boolean
    [key: string]: DbState<any> | (() => boolean)
}

export const defaultTripContextData: TripContextData = {
    trips: defaultDbState<Trip>(),
    stops: defaultDbState<Stop>(),
    stopEquipments: defaultDbState<StopEquipment>(),
    equipmentTypes: defaultDbState<EquipmentType>(),
    equipmentShortReasons: defaultDbState<EquipmentShortReason>(),
    orderItems: defaultDbState<OrderItem>(),
    orders: defaultDbState<Order>(),
    lineItems: defaultDbState<LineItem>(),
    lineItemBarcodes: defaultDbState<LineItemBarcode>(),
    signatures: defaultDbState<Signature>(),
    mispicks: defaultDbState<Mispick>(),
    licensePlates: defaultDbState<LicensePlate>(),
    orderItemChanges: defaultDbState<OrderItemChange>(),
    catchWeights: defaultDbState<CatchWeight>(),
    licensePlateItems: defaultDbState<LicensePlateItem>(),
    orderLicensePlates: defaultDbState<OrderLicensePlate>(),
    reconcileReasons: defaultDbState<ReconcileReason>(),
    refusalReasons: defaultDbState<RefusalReason>(),
    companies: defaultDbState<Company>(),
    verifyMultipleItemsReasons: defaultDbState<VerifyMultipleItemsReason>(),
    returnItems: defaultDbState<ReturnItem>(),
    returnChangeReasons: defaultDbState<ReturnChangeReason>(),
    syncStatus: defaultDbState<SyncStatus>(),
    filteredLicensePlates: defaultDbState<FilteredLicensePlate>(),
    orderItemChangeImages: defaultDbState<OrderItemChangeImage>(),
    companyEmail: defaultDbState<CompanyEmail>(),
    companyEmailAdditions: defaultDbState<CompanyEmail>(),
    companyEmailDeletions: defaultDbState<CompanyEmail>(),
    isReady: () => false
}

export const TripContext = createContext<TripContextData>(defaultTripContextData)

